export default __webpack_public_path__ + "smop-favicon.5b3f652b7958e70da298a8731e479e84.png";